import React from 'react';
import Icon from '../../../Components/Icons/Icon';
import { useOnboarding } from '../OnboardingProvider';
import StepShell from '../Components/StepShell';
import { Link } from 'react-router-dom';

const IntroStep = () => {
    const {next} = useOnboarding();

    return <StepShell
        title="Welcome to getSoapy"
        intro="A few quick questions help us set up the useful bits for your business."
    >
        <div className="space-y-3 text-sm">
            {items.map(item => <div key={item.label} className="flex gap-x-5 surface-2 rounded-lg px-5 py-3 text-balance">
                <span className="text-2xl leading-none pt-[0.25rem]">{item.emoji}</span>
                <span>{item.label}</span>
            </div>)}
        </div>

        <div className="flex justify-between items-center">
            <Link
                to="/login"
                className="my-3 btn btn-secondary"
            >
                Login
            </Link>
            <button
                type="button"
                className="my-3 btn btn-primary"
                onClick={next}
            >
                <span className="flex items-center gap-x-2">Get started <Icon icon="ArrowRight" /></span>
            </button>
        </div>
    </StepShell>;
};

const items = [
    {emoji: '🧼', label: 'Manage your services, customers and regular jobs'},
    {emoji: '📅', label: 'Plan your schedule and route your day'},
    {emoji: '💷', label: 'Send quotes, invoices and payment links'},
    {emoji: '💳', label: 'Collect payments online and automatically'},
    {emoji: '💬', label: 'Keep customer messages and reminders in one place'},
];

export default IntroStep;
